<template>
  <div class="bg-info-light rounded-lg shadow p-3 mt-4">
    <div class="flex items-start">
      <img
        src="@/assets/icons/papsi_info_blue.svg"
        class="w-icon h-icon mr-2 mt-0.5"
      />
      <div class="text-xs text-grey-dark italic">
        <span class="mr-1">
          {{ lang("lbl_0000257") }}
        </span>
        <router-link
          to="/privacy-policy"
          class="no-underline text-blue font-bold italic mr-1"
        >
          {{ lang("lbl_0000135") }}
        </router-link>
        <span>
          {{ lang("lbl_0000258") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "./../../mixin.js";
export default {
  mixins: [mixin],
};
</script>
